const terminalView = {
    namespaced: true,
    state: {
        terminalList: [],
        displaysByGroup: {},
        selectedDisplay: {},
        departureTransfersByTerminal: {},
        stopsByTerminal: {},
        departureTransferGroupsByTerminal: {},
        announcementsByTerminal: {}
    },
    mutations: {
        updateTerminalList(state, newList) {
            state.terminalList = newList;
        },
        updateDisplaysByGroup(state, dbg) {
            state.displaysByGroup = { ...state.displaysByGroup,  [dbg.group]: dbg.displays };
        },
        setSelectedDisplay(state, display) {
            state.selectedDisplay = display;
        },
        setSelectedDisplayAnnouncements(state, announcements) {
            state.selectedDisplay = { ...state.selectedDisplay, ['announcements']: announcements };
        },
        updateDepartureTransfersByTerminal(state, dbg) {
            state.departureTransfersByTerminal = { ...state.departureTransfersByTerminal,  [dbg.terminal]: dbg.transfers };
        },
        updateStopsByTerminal(state, dbg) {
            state.stopsByTerminal = { ...state.stopsByTerminal,  [dbg.terminal]: dbg.stops };
        },
        updateDepartureTransferGroupsByTerminal(state, dbg) {
            state.departureTransferGroupsByTerminal = { ...state.departureTransferGroupsByTerminal,  [dbg.terminal]: dbg.transfers };
        },
        updateAnnouncementsByTerminal(state, abt) {
            state.announcementsByTerminal = { ...state.announcementsByTerminal, [abt.terminal]: abt.announcements };
        }
    },
    actions: {
        getTerminals(context) {
            return new Promise((resolve, reject) => {
                this._vm.$traveller_http.get('/traveller/restui/terminals/getTerminals')
                    .then(response => {
                        if (response.status == 200) {
                            context.commit('updateTerminalList', response.data);
                            resolve(response)
                        } else {
                            reject()
                        }
                    })
                    .catch(error => {
                        reject(error)
                    })
            });
        },
        getGroupDisplays(context, displayGroupId) {
            return new Promise((resolve, reject) => {
                this._vm.$traveller_http.get('/traveller/restui/terminals/getGroupDisplays', { params: { "displaygroupid": displayGroupId } })
                    .then(response => {
                        if (response.status == 200) {
                            context.commit('updateDisplaysByGroup', { group: displayGroupId, displays: response.data });
                            resolve(response)
                        } else {
                            reject()
                        }
                    })
                    .catch(error => {
                        reject(error)
                    })
            });
        },
        getTerminalDepartureTransfers(context, terminalId) {
            return new Promise((resolve, reject) => {
                this._vm.$traveller_http.get('/traveller/restui/terminals/getDepartureTransfers', { params: { "terminalid": terminalId } })
                    .then(response => {
                        if (response.status == 200) {
                            context.commit('updateDepartureTransfersByTerminal', { terminal: terminalId, transfers: response.data });
                            resolve(response)
                        } else {
                            reject()
                        }
                    })
                    .catch(error => {
                        reject(error)
                    })
            });
        },
        saveDepartureTransfer(context, params) {
            return new Promise((resolve, reject) => {
                this._vm.$traveller_http.post('/traveller/restui/terminals/saveDepartureTransfer', params.departureTransfer)
                    .then(response => {
                        if (response.status == 200) {
                            context.dispatch('getTerminalDepartureTransfers', params.terminalId);
                            resolve(response)
                        } else {
                            reject()
                        }
                    })
                    .catch(error => {
                        reject(error)
                    })
            });
        },
        deleteDepartureTransfers(context, params) {
            return new Promise((resolve, reject) => {
                this._vm.$traveller_http.post('/traveller/restui/terminals/deleteDepartureTransfers', params.departureTransferIds)
                    .then(response => {
                        if (response.status == 200) {
                            context.dispatch('getTerminalDepartureTransfers', params.terminalId);
                            resolve(response)
                        } else {
                            reject()
                        }
                    })
                    .catch(error => {
                        reject(error)
                    })
            });
        },
        getTerminalStops(context, terminalId) {
            return new Promise((resolve, reject) => {
                this._vm.$traveller_http.get('/traveller/restui/terminals/getTerminalStops', { params: { "terminalid": terminalId } })
                    .then(response => {
                        if (response.status == 200) {
                            context.commit('updateStopsByTerminal', { terminal: terminalId, stops: response.data });
                            resolve(response)
                        } else {
                            reject()
                        }
                    })
                    .catch(error => {
                        reject(error)
                    })
            });
        },
        getTerminalDepartureTransferGroups(context, terminalId) {
            return new Promise((resolve, reject) => {
                this._vm.$traveller_http.get('/traveller/restui/terminals/getDepartureTransferGroups', { params: { "terminalid": terminalId } })
                    .then(response => {
                        if (response.status == 200) {
                            context.commit('updateDepartureTransferGroupsByTerminal', { terminal: terminalId, transfers: response.data });
                            resolve(response)
                        } else {
                            reject()
                        }
                    })
                    .catch(error => {
                        reject(error)
                    })
            });
        },
        saveDepartureTransferGroup(context, params) {
            return new Promise((resolve, reject) => {
                this._vm.$traveller_http.post('/traveller/restui/terminals/saveDepartureTransferGroup', params.departureTransferGroup)
                    .then(response => {
                        if (response.status == 200) {
                            context.dispatch('getTerminalDepartureTransferGroups', params.terminalId);
                            context.dispatch('getTerminalDepartureTransfers', params.terminalId);
                            resolve(response)
                        } else {
                            reject()
                        }
                    })
                    .catch(error => {
                        reject(error)
                    })
            });
        },
        deleteDepartureTransferGroup(context, params) {
            return new Promise((resolve, reject) => {
                this._vm.$traveller_http.post('/traveller/restui/terminals/deleteDepartureTransferGroup', params.departureTransferGroup)
                    .then(response => {
                        if (response.status == 200) {
                            context.dispatch('getTerminalDepartureTransferGroups', params.terminalId);
                            resolve(response)
                        } else {
                            reject()
                        }
                    })
                    .catch(error => {
                        reject(error)
                    })
            });
        },
        getSelectedDisplayAnnouncements(context) {
            return new Promise((resolve, reject) => {
                this._vm.$traveller_http.get('/traveller/restui/terminals/getTerminalAnnouncements', { params: { "displayid": context.state.selectedDisplay.displayId } })
                    .then(response => {
                        if (response.status == 200) {
                            context.commit('setSelectedDisplayAnnouncements', response.data);
                            resolve(response)
                        } else {
                            reject()
                        }
                    })
                    .catch(error => {
                        reject(error)
                    })
            });
        },
        getTerminalAnnouncements(context, terminalId) {
            return new Promise((resolve, reject) => {
                this._vm.$traveller_http.get('/traveller/restui/terminals/getTerminalAnnouncements', { params: { "terminalid": terminalId } })
                    .then(response => {
                        if (response.status == 200) {
                            context.commit('updateAnnouncementsByTerminal', { terminal: terminalId, announcements: response.data });
                            resolve(response)
                        } else {
                            reject()
                        }
                    })
                    .catch(error => {
                        reject(error)
                    })
            });
        },
        addTerminalDisplayAnnouncement(context, params) {
            return new Promise((resolve, reject) => {
                this._vm.$traveller_http.post('/traveller/restui/terminals/addTerminalDisplayAnnouncement', params.announcement)
                    .then(response => {
                        if (response.status == 200) {
                            context.dispatch('getSelectedDisplayAnnouncements');
                            context.dispatch('getTerminalAnnouncements', params.terminalId);
                            resolve(response)
                        } else {
                            reject()
                        }
                    })
                    .catch(error => {
                        reject(error)
                    })
            });
        },
        removeTerminalDisplayAnnouncementAttachments(context, params) {
            return new Promise((resolve, reject) => {
                this._vm.$traveller_http.post('/traveller/restui/terminals/removeTerminalDisplayAnnouncementAttachments', params.announcement)
                    .then(response => {
                        if (response.status == 200) {
                            if (context.state.selectedDisplay && context.state.selectedDisplay.displayId) {
                                context.dispatch('getSelectedDisplayAnnouncements');
                            }
                            context.dispatch('getTerminalAnnouncements', params.terminalId);
                            resolve(response)
                        } else {
                            reject()
                        }
                    })
                    .catch(error => {
                        reject(error)
                    })
            });
        },
        addTerminalAnnouncement(context, params) {
            return new Promise((resolve, reject) => {
                this._vm.$traveller_http.post('/traveller/restui/terminals/addTerminalAnnouncement', params.announcement)
                    .then(response => {
                        if (response.status == 200) {
                            context.dispatch('getTerminalAnnouncements', params.terminalId);
                            resolve(response)
                        } else {
                            reject()
                        }
                    })
                    .catch(error => {
                        reject(error)
                    })
            });
        },
        removeTerminalAnnouncement(context, params) {
            return new Promise((resolve, reject) => {
                this._vm.$traveller_http.post('/traveller/restui/terminals/removeTerminalAnnouncement', params.announcement)
                    .then(response => {
                        if (response.status == 200) {
                            context.dispatch('getTerminalAnnouncements', params.terminalId);
                            resolve(response)
                        } else {
                            reject()
                        }
                    })
                    .catch(error => {
                        reject(error)
                    })
            });
        }
    }
}
export default terminalView;